// @flow
import React, { useState, useEffect } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import * as UserEditMutation from '../../mutations/UserEditMutation';
import * as UserDeleteMutation from '../../mutations/UserDeleteMutation'
import { UserForm } from './UserForm';

const UserEdit = ({ relay, viewer: { user }, history }) => {
	const [serverError, setServerError] = useState(null);
	useEffect(() => {
		if(user === null) {
			history.push('/users');
		}
	}, [user]);

	const handleSubmit = data => {
		UserEditMutation.commit(relay.environment, {
			...data,
			userId: user.id
		}, (error: ?Error, userId: ?string) => {
			if (error) {
				setServerError({
					field: 'email',
					type: 'required',
					message: 'Email уже занят'
				});
			}
		});
	};

	const handleDelete = () => {
		if (confirm('Вы действитель хотите удалить пользователя')) {
			UserDeleteMutation.commit(relay.environment, {
				id: user.id,
			}, (error: ?Error) => {
				if (!error) {
					history.push('users');
				}
			})
		}
	};

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<UserForm user={user === null ? {} : user} onSubmit={handleSubmit} serverError={serverError}>
				<RaisedButton
					style={{
						marginLeft: 20,
					}}
					labelColor={'#ffffff'}
					onClick={handleDelete}
					backgroundColor={'#f50000'}
					label={'Удалить'}
				/>
			</UserForm>
		</Paper>
	);
};

export default withRouter(
	createFragmentContainer(
		UserEdit,
		graphql`
			fragment UserEdit_viewer on Viewer @argumentDefinitions(id: { type: "ID!" }) {
				id
				user(id: $id) {
					id
					name
					email
					active
					canDelete
					blocked
					testText
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/users/UserEdit.js